import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TabelaPrecoService } from '@app/modules/tabela-preco/services';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Dialog } from 'primeng/dialog';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';

@Component({
  selector: 'app-fast-tabela',
  templateUrl: './fast-tabela.component.html',
  styleUrls: ['./fast-tabela.component.scss'],
  providers: [TabelaPrecoService]
})
export class FastTabelaComponent implements OnInit, AfterViewInit {
  @ViewChild('fastTabelaPreco') fastTabelaPreco: Dialog;
  form: UntypedFormGroup;

  loading = false;

  loadingCodigo = true;

  public messages = {
    codigo: {
      required: 'O código é obrigatório.',
      pattern: 'O código deve conter 3 números.',
      repeated: 'Código já em uso.'
    },
    nome: {
      duplicate: 'Já existe uma tabela de preço com esse nome!',
      required: 'O nome da tabela é obrigatório.',
      maxlength: 'O nome deve conter no máximo 60 caracteres.',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    perc_desc_acresc: {
      required: 'O desconto/acréscimo é obrigatório.',
      pattern: 'Este valor é invalido.',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      max_value: 'Inválido: passou dos limites',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
    }
  };

  constructor(
    private fb: UntypedFormBuilder,
    private tokenService: TokenService,
    public entityService: TabelaPrecoService,
    public dialogRef: MatDialogRef<FastTabelaComponent>,
    protected matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    this.fastTabelaPreco.maximize();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [
        null,
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      perc_desc_acresc: [
        null || 0,
        [
          Validators.required,
          CustomValidators.validateCurrencyValues(5, 2),
          CustomValidators.existSpecialChar(true)
          // Validators.pattern(/^(-)?((100)|(\d{1,3}(.\d*)?))$/)
        ]
      ],
      atualizar_auto: [null !== false]
    });
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    entity = Utils.trimAttributes(entity);
    entity.perc_desc_acresc = Utils.replaceCommaToDot(entity.perc_desc_acresc);
    this.entityService.insert(entity).subscribe(
      tabela_preco => {
        this.matSnackBar.open('Tabela de preço cadastrada.', 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-success']
        });
        this.dialogRef.close(tabela_preco);
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.displayError(err);
      }
    );
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'nome',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
